/**
 * @generated SignedSource<<35075e3a62f9cab91eb3025cebfc9521>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "year"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "year",
                    "variableName": "year"
                }
            ],
            "concreteType": "PublicHolidayFromApi",
            "kind": "LinkedField",
            "name": "admin_getHolidaysFromApi",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isRedDay",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PublicHolidaysApiPanelQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PublicHolidaysApiPanelQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "5f8893c169a0b657c2248096e7f6066e",
            "id": null,
            "metadata": {},
            "name": "PublicHolidaysApiPanelQuery",
            "operationKind": "query",
            "text": "query PublicHolidaysApiPanelQuery(\n  $year: Int!\n) {\n  admin_getHolidaysFromApi(year: $year) {\n    date\n    isRedDay\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "eb15a3f9e59bf87cf70c7c715a8e944b";
export default node;
